export enum EmailFlowActionTypes {
  GET_EMAILS_FOR_EMAIL_FLOW = "[Email Flow] GET_EMAILS",
  SET_EMAILS_FOR_EMAIL_FLOW = "[Email Flow] SET_EMAILS",
  GO_TO_VERIFY_PIN_EMAIL_FLOW = "[Email Flow] GO_TO_VERIFY_PIN",
  GO_BACK_TO_SECOND_STEP_EMAIL_FLOW = "[Email Flow] GO_TO_BACK_2_STEP",
  SEND_EMAIL_FOR_EMAIL_FLOW = "[Email Flow] SEND_EMAIL",
  SEND_SMS_FOR_EMAIL_FLOW = "[Email Flow] SEND_SMS",
  VERIFY_PIN_EMAIL_FLOW = "[Email Flow] VERIFY_PIN",
  SET_PIN_CHECK_ERROR_FOR_EMAIL_FLOW = "[Email Flow] SET_PIN_CHECK_ERROR",
  RESET_PIN_CHECK_ERROR_FOR_EMAIL_FLOW = "[Email Flow] RESET_PIN_CHECK_ERROR",
  BACK_TO_FIRST_STEP_EMAIL_FLOW = "[Email Flow] BACK_TO_FIRST_STEP",
  CANCEL_SESSION_EMAIL_FLOW = "[Email Flow] CANCEL_SESSION",
  GET_SOURCES = "[Email Flow] GET_SOURCES",
  SET_SOURCES = "[Email Flow] SET_SOURCES",
  CONFIRM_SOURCES = "[Email Flow] CONFIRM_SOURCES",
  SET_BTN_LOADING = "[Email Flow] SET_BTN_LOADING",
  CLEAN_BTN_LOADING = "[Email Flow] CLEAN_BTN_LOADING",
}
export interface EmailFlowAction {
  readonly type: EmailFlowActionTypes;
  readonly payload: any;
}

export interface EmailFlowData {
  emailsList: ListItem[];
  contactValue: string;
  phonesList: ListItem[];
  sourceList: sourceList;
  lastUsed: string;
  primaryEmail: string;
  verifyPinError: boolean;
  isLoading: boolean;
}

export interface sourceList {
  Chat?: string;
  Phone?: string;
}
export interface ListItem {
  id: string;
  value: string;
  lockdownInSeconds: number;
}
export interface ResponseItem {
  id: string;
  type: ContactTypes;
  value: string;
  lockdownInSeconds: number;
  hasMask: boolean;
  isLastUsed: boolean;
}
export enum ContactTypes {
  PHONE = "PHONE",
  EMAIL = "EMAIL",
}

export interface ResponseData {
  emailsList: ListItem[];
  phonesList: ListItem[];
  lastUsed: string;
  primaryEmail: string;
}
